<script>
    import { createEventDispatcher } from 'svelte';
    import { generateID } from '../utils/Data.svelte';
    export let modal;
    export let session;
    let loading = false;
    let error = "";
    let es = null;
    
	const dispatch = createEventDispatcher();

    async function confirmHandler() {
        loading = true;
        error = "";
        let [res, err]  = await modal.handler(modal.data);
        loading = false;
		if (err) {
            error = err;
            return;
        }
        var id = generateID();
        var args = {
            container: session.container,
            key: session.key,
            id: modal.data
        };
        
       dispatch('message', {
            type: "modal",
            modal: null
        });
    }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay" aria-label="Close"></div>
    <div class="modal-container">
        <div class="modal-header">
            <button class="btn btn-clear float-right" aria-label="Close"></button>
            <div>{modal.message}</div>
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error">{error}</div>
                </div>
                <div class="tile-action">
                    {#if loading}
                        <button class="btn btn-primary loading">Confirm</button>
                    {:else}
                        <button class="btn btn-primary" on:click={confirmHandler}>Confirm</button>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .error {
        color: red;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>